import { config } from 'cfg'

export const ROUTES_ENDPOINTS = {
  routes: (networkId: number) => `${config.apiBaseUrl}/routes/${networkId}`
}
